import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getToken } from "@/lib/api";

export default function RequireAuth({ children }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  if (!user) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">{t("interface.loading")} </div>
    );
  }
  return children;
}
